function initLastBookAnimation() {
  let sceneController = new ScrollMagic.Controller();
  new ScrollMagic.Scene({triggerElement: ".block--video", triggerHook: 1, duration: 1000})
    .setTween(gsap.from(".video-product", { scale: 1.3, duration: 1, ease: "power1.out" }))
    .addTo(sceneController);
  function initSpecialAnimation() {
    new ScrollMagic.Scene({triggerElement: ".special__illustration", triggerHook: 1, duration: 1500})
      .setTween(".section--book", 1, {translateY: "-30%"})
      .addTo(sceneController);
    new ScrollMagic.Scene({triggerElement: '.section--book',triggerHook: 1, duration: 2000, offset: 600})
      .setTween(gsap.fromTo(".book", { translateY: '50%'}, {translateY: '-100%'}))
      .addTo(infoBlockController);
  }

  if (!isTablet) {
    initSpecialAnimation();
  }
  let img = document.querySelector('.explosion__img-wrapper img');
  let percentStart = Math.round(-window.innerWidth  * 0.3);
  let percentEnd = Math.round(window.innerWidth * 0.2);
  if (isMobile) {
    percentStart = -window.innerWidth * 1.3;
    percentEnd = 440 * 1.2;
  } else if (isTablet) {
    percentEnd = Math.round(window.innerWidth * 0.6);
  }
  let explosionTween = TweenMax.fromTo(img, 1,
    {translateX: percentStart + 'px', scale: isMobile ? 1.5 : 1.3},
    {translateX: percentEnd + 'px', scale: isMobile ? 1 : 1}//, ease: isMobile ? Power1.easeIn : Power1.none
  );
  new ScrollMagic.Scene({
    triggerElement: ".section--pin-explosion",
    triggerHook: 1,
    duration: isMobile? 800 : 2000,
    offset : isMobile? 300 : 0,
  })
    .setTween(explosionTween)
    .addTo(sceneController)

  if (!isTablet) {
    new ScrollMagic.Scene({
      triggerElement: ".section--pin-explosion",
      triggerHook: 0,
      duration: 1100,
      offset: isMobile ? -100 : 0,
    })
      .setPin('.section--explosion')
      .addTo(new ScrollMagic.Controller())
      .on('progress',  (event) => {
        document.querySelector('.section--pin-explosion div').style.transform = `translateY(${event.progress * 1000}px)`;
      })
  }

  let infoParamFrom = {translateY: '120%'};
  let infoParamto = {translateY: '-100%'};
  if (isMobile) {
    infoParamFrom = {translateY: 250};
    infoParamto = {translateY: -550};
  }

  let explosionTextTween = TweenMax.fromTo('.explosion__info', 1,
    infoParamFrom,
    infoParamto
  );
  new ScrollMagic.Scene({
    triggerElement: ".section--explosion",
    triggerHook: isTablet ? 1 : .4,
    duration: 2000,
  })
    .setTween(explosionTextTween)
    .addTo(new ScrollMagic.Controller())

  document.querySelectorAll('.js-rotate-logo').forEach((logo) => {
    let parent = logo.parentNode;
    new ScrollMagic.Scene({triggerElement: parent, triggerHook: 1, duration: 3000})
      .setTween(logo, 0.5, {rotate: '360deg'})
      .addTo(sceneController);
  });

  let specialLast = document.querySelector('.section--special-last');
  if (!specialLast) {
    return;
  }


  new ScrollMagic.Scene({triggerElement: ".section--special-last", triggerHook: 1, duration: 3000})
    .setTween(".special__logo", 0.5, {rotate: '360deg'})
    .addTo(sceneController);

  document.querySelectorAll('.special__planet').forEach((planet, index) => {
    let direction = index % 2 === 0 ? 1 : -1;
    let koef = (index % 2 === 0 ? 1.5 : 1) * (2 / index);
    if (isMobile) {
      koef /= 3;
    }
    let planetTween = TweenMax.fromTo(planet, 1,
      {y: -100 * direction * koef, x: 0},
      {y: 100 * direction * koef, x: 0}
    );
    new ScrollMagic.Scene({triggerElement: ".section--special-last", triggerHook: 1, duration: 3000})
      .setTween(planetTween)
      .addTo(sceneController);
  });

  if (isMobile) {

    let spaceTween1 = TweenMax.fromTo('.space__img', 1,
      {rotate: '270deg'},
      {rotate:'450deg'}
    );
    new ScrollMagic.Scene({
      triggerElement: ".section--space",
      triggerHook: 0.7,
      duration: 2400,
    })
      .setPin('.space__img')
      .setTween(spaceTween1)
      .addTo(sceneController);


    let spaceTween = TweenMax.fromTo('.space__img', 1,
      {rotate: '270deg', translateY: 0},
      {rotate:'450deg', translateY: -700}
    );
    new ScrollMagic.Scene({
      triggerElement: ".section--space",
      triggerHook: .7,
      duration: 2400,
    })
      .setTween(spaceTween)
      .addTo(sceneController);
  } else {

    let spaceTween = TweenMax.fromTo('.space__img', 1,
      {translateY: 0, rotate: '270deg'},
      {translateY: isMobile ? 2500 : 600, rotate: isMobile ? '720deg' : '440deg'}
    );
    new ScrollMagic.Scene({
      triggerElement: ".section--space",
      triggerHook: 0.75,
      duration: isMobile ? 6000 : 3000,
    })
      .setTween(spaceTween)
      .addTo(sceneController);
  }

  let spaceTween2 = TweenMax.fromTo('.section--space-bg', 1,
    {translateY: 0 },
    {translateY: -1000}
  );
  new ScrollMagic.Scene({
    triggerElement: ".section--space",
    triggerHook: 1,
    duration: 3000,
  })
    .setTween(spaceTween2)
    .addTo(sceneController);


  let spaceTween3 = TweenMax.fromTo('.space__title,.space__text:nth-child(1)', 1,
    {translateY: 0 },
    {translateY: isMobile ? -200 : -1000}
  );
  new ScrollMagic.Scene({
    triggerElement: ".section--space",
    triggerHook: .6,
    duration: 3000,
  })
    .setTween(spaceTween3)
    .addTo(sceneController);



  let spaceTween4 = TweenMax.fromTo('.space__text:nth-child(2)', 1,
    {translateY: 0 },
    {translateY: isMobile ? -500 : -1500}
  );
  new ScrollMagic.Scene({
    triggerElement: ".section--space",
    triggerHook: .5,
    duration: 3000,
  })
    .setTween(spaceTween4)
    .addTo(sceneController);


  let spaceTween5 = TweenMax.fromTo('.space__text:nth-child(3)', 1,
    {translateY: 0 },
    {translateY: isMobile ? -500 : -1700}
  );
  new ScrollMagic.Scene({
    triggerElement: ".section--space",
    triggerHook: .5,
    duration: 3000,
  })
    .setTween(spaceTween5)
    .addTo(sceneController);

  new ScrollMagic.Scene({triggerElement: ".block--video-2", triggerHook: 1, duration: 3000})
    .setTween(".process__logo", 0.5, {rotate: '360deg'})
    .addTo(sceneController);
}

window.addEventListener('DOMContentLoaded', initLastBookAnimation);